import Logo from "../../img/logo_huawey.png";
import { IoTicket } from "react-icons/io5";
import { Link, animateScroll as scroll } from "react-scroll";
import LogoHuawey from '../../img/logo_huawey.png'
import LogoWiT from '../../img/logo_wit.png'
import LogoWomo from '../../img/womo_white.png'

function HeaderInternal() {
    return (
        <>
            <header className="py-3 bg-[#AF00A9]">
                <div className="container px-3 mx-auto flex justify-between items-center">
                   <div className="flex gap-4 justify-start items-center text-white max-md:mr-4 max-sm:hidden">
                        <a href="http://www.huawei.com/ua" target="_blank">
                            <img src={LogoHuawey} alt="Huawei"
                                className="w-[100px]" />
                        </a>
                        /
                        <a href="https://womo.ua/" target="_blank">
                            <img src={LogoWomo} alt="Womo"
                                className="w-[80px]" />
                        </a>
                        /
                        <a href="http://www.womenintech.com.ua" target="_blank">
                            <img src={LogoWiT} alt="Logo HRWS"
                                className="w-[85px]" />
                        </a>
                    </div>
                    <nav>
                        <ul className="flex gap-4 text-white">
                            <li><a href="/">Головна</a></li>
                        </ul>
                    </nav>
                </div>

            </header>
        </>
    )
}

export default HeaderInternal;